// @flow
import React from "react";
import styled from "styled-components";

const Icon = styled.span`
  color: ${props => props.color || props.theme.accent};
`;

type Props = {
  className?: string,
  color?: string
};

export const tournamentCurrency = {
  symbol: "T¢",
  rawSymbol: "T¢",
  internationalSymbol: {
    abbr: "LOL",
    default: "T¢"
  },
  // bids: [5, 10, 20, 30, 50, 100, 150, 200],
  // initialDeposit: 1000,
  // minFillup: 10,
  // minWithdraw: 20,
  // vipPayment: 900,
  // minBidAmount: 1,
  pattern: ["sign", "value", "space", "symbol"]
};

export default (props: Props) => (
  <Icon className={props.className} color={props.color}>
    {props.children}
  </Icon>
);



// WEBPACK FOOTER //
// ./src/components/Icons/Kuchka.js